import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/navbar.component';
import Footer from './components/footer.component';
import Video from './components/video.component';
import DiscordJoin from './components/discord-join.component';
import SteamWishlist from './components/steam-wishlist.component';
import Socials from './components/socials.component';
import Faq from './components/faq.component';
import RelicsStats from './components/relics-stats.component';
import LeadersStats from './components/leaders-stats.component';
import ReportBug from './components/report-bug.component';
import Team from './components/team.component';
import Merch from './components/merch.component';
import './App.css';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={
                    <div className="App">
                        <Navbar />
                        <main className="App-content">
                            <div className="App-page home-page">
                                <Video videoId="YfE9-npV2BI" />
                                <SteamWishlist />
                            </div>
                        </main>
                        <Footer />
                    </div>
                } />
                <Route path="/socials" element={
                    <div className="App">
                        <Navbar />
                        <main className="App-content">
                            <Socials />
                        </main>
                        <Footer />
                    </div>
                } />
                <Route path="/faq" element={
                    <div className="App">
                        <Navbar />
                        <main className="App-content">
                            <Faq />
                        </main>
                        <Footer />
                    </div>
                } />
                <Route path="/relics" element={
                    <div className="App">
                        <Navbar />
                        <main className="App-content">
                            <RelicsStats />
                        </main>
                        <Footer />
                    </div>
                } />
                <Route path="/leaders" element={
                    <div className="App">
                        <Navbar />
                        <main className="App-content">
                            <LeadersStats />
                        </main>
                        <Footer />
                    </div>
                } />
                <Route path="/report-bug" element={
                    <div className="App">
                        <Navbar />
                        <main className="App-content">
                            <ReportBug />
                        </main>
                        <Footer />
                    </div>
                } />
                <Route path="/team" element={
                    <div className="App">
                        <Navbar />
                        <main className="App-content">
                            <Team />
                        </main>
                        <Footer />
                    </div>
                } />
                <Route path="/subscribe" element={
                    <div className="App">
                        <Navbar />
                        <main className="App-content">
                            <Merch />
                        </main>
                        <Footer />
                    </div>
                } />
                </Routes>
        </Router>
    );
}

export default App;
